import { render, staticRenderFns } from "./PopularCases.vue?vue&type=template&id=dd65ad2e&scoped=true&"
import script from "./PopularCases.vue?vue&type=script&lang=js&"
export * from "./PopularCases.vue?vue&type=script&lang=js&"
import style0 from "./PopularCases.vue?vue&type=style&index=0&id=dd65ad2e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd65ad2e",
  null
  
)

export default component.exports